import React from 'react';

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  subtitle?: string;
  align?: 'left' | 'center';
  /** Heading level for document outline. Defaults to 2. */
  as?: 'h1' | 'h2' | 'h3';
}

const SectionHeading: React.FC<SectionHeadingProps> = ({
  eyebrow,
  title,
  subtitle,
  align = 'center',
  as: Heading = 'h2',
}) => {
  const alignClass = align === 'left' ? 'text-left' : 'text-center';

  return (
    <div className={alignClass}>
      {eyebrow && (
        <p className="text-sm font-semibold uppercase tracking-wide text-primary-600">
          {eyebrow}
        </p>
      )}
      <Heading className="text-3xl sm:text-4xl font-bold text-gray-900">{title}</Heading>
      {subtitle && <p className="mt-4 text-lg text-gray-600">{subtitle}</p>}
    </div>
  );
};

export default SectionHeading;
